import Tip from '../components/Tip';
import BannerC from '../components/BannerC';
import SeeMuch from '../components/SeeMuch';
import SuperchargeSectionStatusC from '../components/SuperchargeSectionStatusC';
import ExclusiveSectionStatusC from '../components/ExclusiveSectionStatusC';
import SuperchargeSolarStatusC from '../components/SuperchargeSolarStatusC';
import ExperienceApp from '../components/ExperienceApp';
import FAQSection from '../components/FAQSection';
import TCSection from '../components/TCSection';
export default function StatusItem() {
    return (
        <>
            <Tip />
            <BannerC />
            <ExclusiveSectionStatusC />
            <SeeMuch />
            <SuperchargeSectionStatusC />
            <ExperienceApp />
            <SuperchargeSolarStatusC />
            <FAQSection />
            <TCSection />
        </>
    );
}
